export default __webpack_public_path__ + "static/media/halu-logo.1acdae91.png";